import { useAjax, useUrlParamsDecode, useUrlParamsEncode, useUrlParamsValue } from "@bsm/component"
import { useCallback } from "react"

export const useRedirectToApp = () => {
    const ajax = useAjax()

    const { r } = useUrlParamsValue<RedirectionParams>()
    const urlDecode = useUrlParamsDecode()
    const urlEncode = useUrlParamsEncode()
    
    return useCallback(() => {

        if (r) {
            const [url] = r.split('?')
            const returnUrlParams = urlDecode(r)
            const params = { ...returnUrlParams, _t: ajax?.get_token() }
            console.log(url, params, `${url}?${urlEncode(params)}`)
            window.location.href = `${url}?${urlEncode(params)}`
            return;
        }

        window.location.href = `/`
    }, [r])
}

type RedirectionParams = {
    r?: string
}
